import ForgotPasswordModule from "@/modules/ForgotPassword";

function ForgotPasswordPage() {
  return <ForgotPasswordModule />;
}

export default ForgotPasswordPage;
